(function() {
    'use strict';

    angular
        .module('platformRental')
        .controller('PlatformRentalLogoutController', PlatformRentalLogoutController);

    PlatformRentalLogoutController.$inject = ['AuthService', '$state'];

    /* @ngInject */
    function PlatformRentalLogoutController(AuthService, $state) {
        var vm = this;

        activate();

        function activate() {
            AuthService.logout().then(function () {
                console.log('logou platform rentals');
                return $state.go('platformRental.login');
            });
        }
    }
})();